import { DialogTitle } from "lib/headlessui/components/dialog/dialog";
import { XMarkIcon } from "@heroicons/react/24/outline";
import React from "react";

interface ResponsivePanelMobileHeaderProps {
    headerText: string;
    onDismiss: () => void;
}

export const ResponsivePanelMobileHeader: React.FC<ResponsivePanelMobileHeaderProps> = ({
    headerText,
    onDismiss,
}) => {
    return (
        <div className="flex items-center justify-between px-4 py-3 border-b border-gray-200">
            <button
                type="button"
                className="rounded-md text-gray-400 hover:text-gray-500 focus:outline-none"
                onClick={onDismiss}>
                <span className="sr-only">Close</span>
                <XMarkIcon className="h-6 w-6" aria-hidden="true" />
            </button>
            <DialogTitle className="text-lg font-medium text-gray-900 flex-1 text-center mx-4">
                {headerText}
            </DialogTitle>
            <div className="w-6"></div>
        </div>
    );
};
